import getState, { generateGUID, isBypass } from "../utils/MainHelper";
import MainServices from "./Main.services";

class TrackFeatureServices {
    constructor() {
        this.sqs = "https://sqs.ap-southeast-1.amazonaws.com/788016873502/OneIntelligenceFeatureUI";
        this.featureList = {
            permAnalysis: "Permission/Get Analysis", //done
            permMarketPackage: "Permission/Get Market Package", //done
            permQuickReport: "Permission/Get Quick Report", //done
            permAdvertiser: "Permission/Get Advertiser",  //done
            permLob: "Permission/Get LOB",  //done
            minifiedEntities: "Minified/Get Entities", //done
            minifiedResult: "Minified/Get Result", //done
            minifiedLFInsights: "Minified/Get Lower Funnel Insights", //done
            minifiedMFInsights: "Minified/Get Mid Funnel Insights", //done
            minifiedUFInsights: "Minified/Get Upper Funnel Insights", //done
            minifiedLFPersona: "Minified/Get Lower Funnel Persona", //done
            minifiedMFPersona: "Minified/Get Mid Funnel Persona", //done
            minifiedUFPersona: "Minified/Get Upper Funnel Persona", //done
            minifiedLFReLoadPersona: "Minified/Reload Lower Funnel Persona", //done
            minifiedMFReLoadPersona: "Minified/Reload Mid Funnel Persona", //done
            minifiedUFReLoadPersona: "Minified/Reload Upper Funnel Persona", //done
            minifiedClickInsights: "Minified/Click Insights", //done
            minifiedLFCreatePackage: "Minified/Create Package Lower Funnel", //done
            minifiedMFCreatePackage: "Minified/Create Package Mid Funnel", //done
            minifiedUFCreatePackage: "Minified/Create Package Upper Funnel", //done
            minifiedCreatePackage: "Minified/Create Package", //done
            minifiedLFUpdatePackage: "Minified/Update Package Lower Funnel", //done
            minifiedMFUpdatePackage: "Minified/Update Package Mid Funnel", //done
            minifiedUFUpdatePackage: "Minified/Update Package Upper Funnel", //done
            minifiedUpdatePackage: "Minified/Update Package", //done
            advanceSavantRead: "Advance Analysis/Savant Read", //done
            advanceRunFullMarkerAnalysis: "Advance Analysis/Run Full Market Analysis", //done
            advanceRunPrebuilt: "Advance Analysis/Run Pre-built Analysis", //done
            advanceRunCategoryAnalysis: "Advance Analysis/Run Category Analysis", //done
            advanceRunOpenAnalysis: "Advance Analysis/Run Open Analysis", //done
            advanceClickInsights: "Advance Analysis/Click Insights", //done
            advanceFullMarketTile: "Advance Analysis/Run Full Market Tile", //done
            advanceRunDeepDive: "Advance Analysis/Run Deep Dive", //done
            advanceRunDeepDiveSubjects: "Advance Analysis/Run Deep Dive Subjects", //done
            advanceRunCompare: "Advance Analysis/Run Compare", //done
            advanceRunNewCategoryAnalysis: "Advance Analysis/Run New Category Analysis", //done
            advanceAddToTableCategorysis: "Advance Analysis/Add To Table Category Analysis", //done
            advanceAddFreeForm: "Advance Analysis/Add Free-form", //done
            advanceCreatePackage: "Advance Analysis/Create Package", //done
            advanceUpdatePackage: "Advance Analysis/Update Package", //done
            actionsPublishDashboard: "Actions/Publish Dashboard", //done
            whitespaceRunCustomTreatmentJourney: "Whitespace/Run Custom Treatment Journey", //done
            whitespaceRunStandardTreatmentJourney: "Whitespace/Run Standard Treatment Journey", //done
            whitespaceRunOtherTherapyAreas: "Whitespace/Run Other Therapy Areas", //done
            whitespaceRunDeepDive: "Whitespace/Run Deep Dive", //done
            whitespaceGetCategoryLine: "Whitespace/Get Category Line", //done
            whitespaceAppendNewReports: "Whitespace/Append New Reports", //done
            whitespaceGenerateNewReports: "Whitespace/Generate New Reports", //done
            whitespaceRunConsumerJourney: "Whitespace/Run Consumer Journey", //done
            whitespaceRunOtherConsumerEngage: "Whitespace/Run Other Consumer Engagement", //done
            whitespaceDeepdive10Keywords: "Whitespace/Deep Dive 10 Keywords", //done
            scrapeTopic: "Scrape/Topic",
            scrapeTopicList: "Scrape/TopicList",
            scrapeTopicStatus: "Scrape/TopicStatus",
            addTopicBrand: "MOKB/AddTopicBrand"
        }
    }

    getTrackDate() {
        const currentDate = new Date();
        const options = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZone: 'UTC'
        };
        return currentDate.toLocaleString('en-US', options);
    }
    trackFeature(featureName, _function, requestBody = {}) {
        const appVersion = process.env.REACT_APP_VERSION
        if (appVersion === "Development") {
            return
        }
        const { setup: {
            country: {
                name: countryName
            },
            marketPackage: {
                title: moduleName,
                parent: {
                    title: marketPackageName
                }
            }
        } } = getState("buildTargets");

        try {
            const account = MainServices.getAccount();
            const { username } = MainServices.userDetails();
            const trackData = {
                appVersion,
                featureName,
                trackDate: this.getTrackDate(),
                _function,
                _username: username,
                _account: account,
                marketPackageName,
                moduleName,
                countryName,
                ...requestBody
            }
            MainServices.sqsSendMessage(this.sqs, JSON.stringify(trackData));
        } catch (error) { }
    }

    getMonitor(monitorParams) {
        const { featureKey, featureName, feature_id, country } = monitorParams || {};
        const commonParams = {
            featureKey,
            featureName,
            country,
            feature_id: feature_id || generateGUID(),
            request: `request/${generateGUID()}.json`,
            response: `response/${generateGUID()}.json`
        }

        const startMonitor = (requestObj = {}, others = {}) => {
            if (!isBypass()) {
                MainServices.uploadFile(commonParams.request, JSON.stringify(requestObj), {}, "monitor")
            }
            this.monitorFeature({
                ...commonParams,
                ...others
            })

        }

        const endMonitor = (responseObj = {}, others = {}) => {
            if (!isBypass()) {
                MainServices.uploadFile(commonParams.request, JSON.stringify(responseObj), {}, "monitor")
            }
            // this.monitorFeature({
            //     ...commonParams,
            //     startEnd: "end",
            //     ...others
            // })
        }

        const getNewRequestResponse = () => {
            return {
                request: `request/${generateGUID()}.json`,
                response: `response/${generateGUID()}.json`
            }
        }

        return {
            startMonitor,
            endMonitor,
            commonParams,
            getNewRequestResponse
        }
    }

    monitorFeature(parameters) {
        const {
            featureKey, feature_id, url, country = null, request, response, startEnd = "start", featureName
        } = parameters
        const params = {
            app: "ONE Intelligence",
            version: process.env.REACT_APP_VERSION.replace(/-/g, "."),
            feature: this.featureList[featureKey] || featureName,
            feature_id,
            url,
            country,
            request,
            response,
            startEnd
        }
        if (isBypass()) {
            // console.log(params);
        }
        MainServices.apiMonitoring(params, isBypass())
    }

}

export default new TrackFeatureServices();
